import { GlFilteredSearchSuggestion } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { capitalizeFirstCharacter } from '~/lib/utils/text_utility';
import BaseToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { HEALTH_SUGGESTIONS, DEFAULT_HEALTH_STATUSES } from '../constants';
export default {
    name: 'HealthToken',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        active: {
            type: Boolean,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        defaultHealth () {
            return this.config.defaultHealth || DEFAULT_HEALTH_STATUSES;
        }
    },
    methods: {
        capitalizeFirstCharacter
    },
    HEALTH_SUGGESTIONS
};
